<template>
  <div>
    <Table
      :columns="columns"
      :data="index"
      :isDeletable="true"
      :isUpdatable="true"
      :isRowClickable="true"
      :isSelectable="true"
      :selectableRowFilter="(row) => !row.signedUp"
      @rowClick="goToProfile"
      @click.capture="preventCheckboxNavigation"
      @delete="deleteProfile"
      @update="(row) => (editingProfileId = row.id)"
      @new-selected-rows="(rows) => $emit('selected-rows', rows)"
    >
      <template #signedUp="{ row }">
        <div class="flex items-center">
          <FieldSpan
            :style-to-add="row.signedUp ? 'text-green-800 bg-green-200' : 'text-red-800 bg-red-200'"
            :value="row.signedUp ? 'Oui' : 'Non'"
          />
          <div
            class="text-sm text-gray-900 cursor-pointer hover:underline hover:text-primary-dark flex items-center ml-2"
            @click.stop="copySignupUrl(row)"
            v-if="!row.signedUp"
          >
            <ClipboardCopyIcon class="h-5" />
          </div>
        </div>
      </template>
    </Table>
    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :totalCount="totalCount"
      @changePage="fetchProfiles"
    />
    <FullScreenModal v-if="editingProfileId" :open="true" @close="editingProfileId = null">
      <MerchantProfileFormEdit :merchantProfileId="editingProfileId" @success="profileUpdated" />
    </FullScreenModal>
  </div>
</template>

<script>
import { FullScreenModal, Table, Pagination, FieldSpan } from "@estaly/ui";
import MerchantProfileFormEdit from "@/components/merchant_profiles/MerchantProfileFormEdit.vue";
import { ClipboardCopyIcon } from "@heroicons/vue/outline";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    Table,
    Pagination,
    FieldSpan,
    ClipboardCopyIcon,
    FullScreenModal,
    MerchantProfileFormEdit,
  },
  props: {
    page: {
      type: Number,
      required: false,
      default: 1,
    },
    keywords: {
      type: String,
      required: false,
    },
    organizationIds: {
      type: Array,
      default: () => [],
    },
    storeIds: {
      type: Array,
      default: () => [],
    },
    roles: {
      type: Array,
      default: () => [],
    },
    signedUp: {
      type: [Boolean, null],
      default: null,
    },
  },
  data() {
    return {
      editingProfileId: null,
      editingUserOrganizationId: null,
      columns: [
        { label: "ID", field: "id", widthClass: "w-16" },
        { label: "Email", field: "email" },
        { label: "Nom", field: "fullName" },
        { label: "Rôle", field: "translatedRole" },
        { label: "Inscrit", field: "signedUp", slot: "signedUp" },
      ],
    };
  },
  computed: {
    ...mapState("merchantProfiles", ["index", "currentPage", "totalPages", "totalCount"]),
  },
  mounted() {
    this.fetchProfiles(this.page);
  },
  watch: {
    keywords() {
      this.fetchProfiles();
    },
    organizationIds() {
      this.fetchProfiles();
    },
    storeIds() {
      this.fetchProfiles();
    },
    roles() {
      this.fetchProfiles();
    },
    signedUp() {
      this.fetchProfiles();
    },
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("merchantProfiles", ["fetchIndex", "delete"]),
    fetchProfiles(page = 1) {
      this.fetchIndex({
        page,
        keywords: this.keywords,
        organizationIds: this.organizationIds,
        storeIds: this.storeIds,
        roles: this.roles,
        signedUp: this.signedUp,
      });
    },
    preventCheckboxNavigation(event) {
      if (event.target.type === "checkbox") {
        event.stopPropagation();
      }
    },
    goToProfile(row) {
      this.$router.push(`/merchant_profiles/${row.id}`);
    },
    copySignupUrl(row) {
      navigator.clipboard.writeText(row.signupUrl);
      this.notify({
        category: "simple",
        type: "success",
        title: "Lien d'inscription copié",
      });
    },
    async deleteProfile(profile) {
      if (!confirm("Supprimer ce profil ?")) return;
      const deleted = await this.delete(profile.id);
      if (!deleted) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Profil supprimé",
      });

      await this.fetchProfiles(this.currentPage);
    },
    async profileUpdated() {
      this.editingProfileId = null;
      await this.fetchProfiles(this.currentPage);
    },
  },
};
</script>
